import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ChangesModel } from 'projects/phdsoft/common/src/lib/models/changes.model';
import { ChangesWorkflowService } from 'src/app/template/changes-workflow/changes-workflow.service';
import { FieldConfig } from '../field.interface';
import { ChangeJustificationComponent } from './change-justification/change-justification.component';
@Component({
  selector: 'c4dweb-input',
  templateUrl: './c4dweb-input.component.html',
  styleUrls: ['./c4dweb-input.component.scss'],
})
export class C4dWebInputComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  originalValue: any;
  private readonly decimalPattern = /^-?(?:(?:\d+(?:[.,]\d*)?)|(?:[.,]\d+))%?$/;

  @Output() eventChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private readonly changesWorkflowService:ChangesWorkflowService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.originalValue = this.field.value
  }

  get inputType(): string {
    return this.isDecimalField ? 'text' : this.field?.inputType;
  }

  get inputMode(): string {
    return this.isDecimalField ? 'decimal' : null;
  }

  private get isDecimalField(): boolean {
    if (this.field?.inputType === 'number') {
      return true;
    }

    const fieldName = this.field?.name?.toLowerCase();
    return [
      'thickness_mm',
      'rulethickness_mm',
      'baselinethickness_mm',
      'webthickness_mm',
      'webrulethickness_mm',
      'webbaselinethickness_mm',
      'flangethickness_mm',
      'flangerulethickness_mm',
      'flangebaselinethickness_mm',
      'wastageallowance',
    ].includes(fieldName);
  }

  private isValidDecimal(value: any): boolean {
    if (value == null || value === '') {
      return false;
    }

    if (typeof value === 'number') {
      return Number.isFinite(value);
    }

    return this.decimalPattern.test(value.toString().trim());
  }

  private normalizeDecimal(value: any): string {
    return value?.toString().trim().replace(/%/g, '').replace(',', '.');
  }

  changeValue(id, $event): void {
    let strValue: any = '';
    if (this.group != null) {
      strValue = this.group?.get(id)?.value;
    } else {
      strValue = $event?.target?.value ?? $event;
    }

    if (this.isDecimalField) {
      if (!this.isValidDecimal(strValue)) {
        this.changesWorkflowService.removeChange(id);
        return;
      }

      strValue = this.normalizeDecimal(strValue);
    }

    const ret = {
      fieldId: id,
      value: strValue,
      original: this.originalValue
    };

    let dialogRef = this.dialog.open(ChangeJustificationComponent, {
      height: '400px',
      width: '600px',
      data: ret,
    });

    let change: ChangesModel = {
      fieldName: id,
      newValue: strValue,
      originalValue: this.originalValue
    }

    this.changesWorkflowService.addChange(change)
    this.eventChange.emit(ret);
  }
}
